import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "diagramTranslationEditor"
};
const _hoisted_2 = {
  class: "editorBlock"
};
const _hoisted_3 = {
  class: "editorTitle"
};
const _hoisted_4 = {
  class: "editorWrapper"
};
const _hoisted_5 = {
  class: "diagramTranslationFooter"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_diagram_editor = _resolveComponent("diagram-editor");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_w_dialog = _resolveComponent("w-dialog");
  return _openBlock(), _createBlock(_component_w_dialog, {
    visible: _ctx.visible,
    title: _ctx.$t('speachTranslation.manage.diagramEditor.title'),
    width: '960px',
    "close-on-outside-click": false,
    onOnDialogClose: _ctx.onCancel
  }, {
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_standard_button, {
      outlined: true,
      label: _ctx.$t('speachTranslation.manage.diagramEditor.cancel'),
      onAction: _ctx.onCancel
    }, null, 8, ["label", "onAction"]), _createVNode(_component_standard_button, {
      loading: _ctx.saving,
      disabled: _ctx.shouldDisableSaveButton,
      label: _ctx.$t('speachTranslation.manage.diagramEditor.save'),
      onAction: _ctx.onSave
    }, null, 8, ["loading", "disabled", "label", "onAction"])])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('speachTranslation.manage.diagramEditor.translationLabel')) + " (" + _toDisplayString(_ctx.targetLangLabel) + ")", 1), _createElementVNode("div", _hoisted_4, [_createVNode(_component_diagram_editor, {
      id: _ctx.chapterId,
      "diagram-data": _ctx.diagramData,
      "vision-enabled": _ctx.visionEnabled,
      "open-edit-mode": true,
      "hide-actions-buttons": true,
      processing: _ctx.saving,
      onChange: _ctx.onDiagramChange
    }, null, 8, ["id", "diagram-data", "vision-enabled", "processing", "onChange"])])])])]),
    _: 1
  }, 8, ["visible", "title", "onOnDialogClose"]);
}